export default __webpack_public_path__ + "static/media/add_cart.187d1226.png";